import { render } from "./selectItems.vue?vue&type=template&id=5943afde"
import script from "./selectItems.vue?vue&type=script&lang=js"
export * from "./selectItems.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\甘小星\\Desktop\\sakai-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__